<template>
    <div v-loading="loader">
        <div class="row">
            <div class="col-md-12">
                <div class="card buttonsDiv">
                    <el-button v-for="monthNumber in months.length"
                               :class="{ 'el-button--primary': month == monthNumber-1 }"
                               @click="getTableData(monthNumber-1)">{{months[monthNumber-1]}}
                    </el-button>
                    <el-date-picker v-on:change="dateChange"
                                    v-model="dateRange"
                                    type="daterange"
                                    placeholder="Wybierz zakres daty"
                                    range-separator=","
                                    format="yyyy-MM-dd"
                                    change="loading">
                    </el-date-picker>
                    <json-excel class="el-button el-button--default" v-if="!getExcelPermission()"
                                :data="jsonData"
                                :fields1="json_fields1"
                                :fields2="json_fields2"
                                v-on:onPrepareExportData="prepareExportData"
                                :name="`raport_pitformat_${lic}_${excelDate}.xls`">Eksport do excela
                    </json-excel>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4" v-if="!disableOnline">
                <div class="card">
                    <download-table :columns-names="table1.names" title="Podsumowanie" sub-title=""
                                    :data="tableDataExeOnline"
                                    :columns="table1.columns" :sum="calculateSum(tableDataExeOnline)">
                    </download-table>
                </div>
            </div>
            <div class="col-md-12">

                <div class="card">
                    <download-table :columns-names="table1.names" title="Instalacyjna" sub-title="" :data="tableDataExe"
                                    :columns="table1.columns" :sum="calculateSum(tableDataExe)">

                    </download-table>
                </div>
            </div>
            <div class="col-md-4" v-if="!disableOnline">
                <div class="card">
                    <download-table :columns-names="table1.names" title="Online" sub-title="" :data="tableDataOnline"
                                    :columns="table1.columns" :sum="calculateSum(tableDataOnline)">

                    </download-table>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
  import DownloadTable from 'components/UIComponents/DownloadTable.vue'
  import ApiLocalStorage from 'src/helpers/ApiLocalStorage'
  import moment from 'moment'
  import JsonExcel from 'components/UIComponents/JsonExcel.vue'

  const tableColumns = ['date', 'download', 'first', 'strong', 'fills', 'amount']
  const columnsNames = ['Dzień', 'Pobrania', 'Pierwsze uruchomienia', 'Strong', 'Wypełnienie', 'Kwota']
  export default {
    components: {
      DownloadTable, JsonExcel
    },
    data () {
      return {
        jsonData: [],
        month: '',
        loader: false,
        tableDataExe: [],
        tableDataOnline: [],
        tableDataExeOnline: [],
        table1: {
          title: 'Instalacyjna',
          subTitle: 'Here is a subtitle for this table',
          columns: [...tableColumns],
          data: this.tableData,
          names: [...columnsNames]
        },
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec'],
        dateRange: '',
        excelDate: '',
        json_fields1: {
          'Instalacyjna': 6
        },
        json_fields2: [
          'Dzien', 'Pobr.', 'Pierwsze Uruch.', 'Uruch. Twarde', 'Wyp', 'Kwota'
        ],
        disableOnline: false
      }
    },
    mounted () {
      this.disableOnline = this.getPermission('disableOnline')
      this.loader = true
      this.getTableData(0)
    },
    computed: {
      lic () {
        return this.$store.getters.lic
      }
    },
    watch: {
      lic: function () {
        this.getTableData(this.month)
      }
    },
    methods: {
      getExcelPermission () {
        return this.getPermission('hideAmounts')
      },
      getTableData (date, range) {
        this.loader = true
        if (range !== 1) {
          this.month = date

          let firstDay = new Date(new Date().getFullYear(), date, 1)
          let lastDay = new Date(new Date().getFullYear(), date + 1, 0)
          date = moment(firstDay).format('YYYY-MM-DD') + ',' + moment(lastDay).format('YYYY-MM-DD')
        }
        ApiLocalStorage.requestData('table' + date + this.lic, 'api/legacy/sum-all', 'post', {
          'lic': this.lic,
          'period': date
        }, 900000).then((response) => {
          this.excelDate = date
          this.tableDataExe = response.values.exe
          this.tableDataOnline = response.values.online
          this.tableDataExeOnline = this.calculateTable(this.tableDataExe, this.tableDataOnline)
          this.prepareExportData()
          setTimeout(() => {
            this.loader = false
          }, 1)
        })
      },
      calculateTable (exe, online) {
        let table = []
        for (let i = 0; i < exe.length; i++) {
          table[i] = {
            date: exe[i].date,
            download: exe[i].download + online[i].download,
            first: exe[i].first + online[i].first,
            strong: exe[i].strong + online[i].strong,
            fills: exe[i].fills + online[i].fills,
            amount: exe[i].amount + online[i].amount
          }
        }
        return table
      },
      calculateSum (data) {
        let sum = {
          download: 0,
          first: 0,
          strong: 0,
          fills: 0,
          amount: 0
        }
        data.forEach((value) => {
          sum.download += value.download
          sum.first += value.first
          sum.strong += value.strong
          sum.fills += value.fills
          sum.amount += value.amount
        })
        return sum
      },
      dateChange (date) {
        this.getTableData(date, 1)
      },
      prepareExportData () {
        let exe = this.tableDataExe

        let sumAll = Object.values(this.calculateSum(this.tableDataExe))
        let dataAll = []
        for (let i = 0; i < this.tableDataExe.length; i++) {
          dataAll[i] = [
            exe[i]['date'], exe[i]['download'], exe[i]['first'], exe[i]['strong'], exe[i]['fills'], exe[i]['amount']
          ]
        }
        for (let i = 0; i < dataAll.length; i++) {
          for (let j = 0; j < dataAll[i].length; j++) {
            dataAll[i][j] = this.numberFormatter(dataAll[i][j])
          }
        }
        for (let i = 0; i < sumAll.length; i++) {
          sumAll[i] = this.numberFormatter(sumAll[i])
        }
        sumAll.splice(0, 0, 'Suma')
        dataAll.push(sumAll)
        this.jsonData = dataAll
      }
    },
    dateChange (date) {
      this.getTableData(date, 1)
    }
  }
</script>
<style>

    .buttonsDiv {
        padding: 15px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// DownloadStats.vue?e4e00d50